import { motion } from 'framer-motion'
import { Database, FileText, MessageSquare, Search } from 'lucide-react'

const nodes = [
  { id: 'docs', x: 20, y: 30, icon: FileText, label: 'Docs' },
  { id: 'data', x: 80, y: 25, icon: Database, label: 'Data' },
  { id: 'search', x: 15, y: 70, icon: Search, label: 'RAG' },
  { id: 'agent', x: 75, y: 75, icon: MessageSquare, label: 'Agent' },
  { id: 'knowledge', x: 50, y: 50, icon: null, label: 'Knowledge', main: true },
]

const edges = [
  ['docs', 'knowledge'],
  ['data', 'knowledge'],
  ['search', 'knowledge'],
  ['agent', 'knowledge'],
  ['docs', 'search'],
  ['data', 'agent'],
]

export function BrainMockup() {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-xl bg-surface-elevated p-6 shadow-2xl">
      <div className="absolute inset-0 bg-grid opacity-40" />

      <svg viewBox="0 0 100 100" className="relative z-10 h-full w-full max-w-md">
        <defs>
          <linearGradient id="brain-line" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8b5cf6" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#a78bfa" stopOpacity="0.8" />
          </linearGradient>
        </defs>

        {edges.map(([from, to], i) => {
          const a = nodes.find((n) => n.id === from)
          const b = nodes.find((n) => n.id === to)
          if (!a || !b) return null
          return (
            <motion.line
              key={`${from}-${to}`}
              x1={a.x}
              y1={a.y}
              x2={b.x}
              y2={b.y}
              stroke="url(#brain-line)"
              strokeWidth="0.5"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              transition={{ duration: 1, delay: i * 0.15 }}
            />
          )
        })}

        {nodes.map((node, i) => (
          <motion.g
            key={node.id}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 + i * 0.1 }}
          >
            <motion.circle
              cx={node.x}
              cy={node.y}
              r={node.main ? 10 : 6}
              fill={node.main ? '#8b5cf6' : '#1e1b2e'}
              stroke={node.main ? '#a78bfa' : '#8b5cf6'}
              strokeWidth="0.8"
              animate={node.main ? { r: [10, 11, 10] } : {}}
              transition={node.main ? { repeat: Infinity, duration: 3 } : {}}
            />
            {node.icon && (
              <foreignObject x={node.x - 3} y={node.y - 3} width={6} height={6}>
                <div className="flex h-full w-full items-center justify-center text-white">
                  <node.icon className="h-3 w-3" />
                </div>
              </foreignObject>
            )}
            <text
              x={node.x}
              y={node.y + (node.main ? 16 : 11)}
              textAnchor="middle"
              className="fill-text-secondary text-[3px] font-medium"
            >
              {node.label}
            </text>
          </motion.g>
        ))}

        {[...Array(4)].map((_, i) => (
          <motion.circle
            key={i}
            cx={50}
            cy={50}
            r={14 + i * 8}
            fill="none"
            stroke="#8b5cf6"
            strokeWidth="0.2"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 0.15, 0], scale: [1, 1.1, 1.2] }}
            transition={{ repeat: Infinity, duration: 3, delay: i * 0.7, ease: 'easeOut' }}
          />
        ))}
      </svg>
    </div>
  )
}
